module.exports = __webpack_public_path__ + "img/trash-white.eb7bc566.svg";